// extracted by mini-css-extract-plugin
export default {"attachments":"styles_attachments__OEYmb","icon":"styles_icon__FHCAi","nativeFileInput":"styles_nativeFileInput__pJs5U","fileInput":"styles_fileInput__+e0ck"};